<template>
  <div>
    <div class="footer">
      <div class="fot_item">
        <img src="@/assets/footer/public_shield.png" class="icon20" alt="" srcset="">
        <span>鄂B-20210472</span>
        <span style="margin-left: 10px;">鄂ICP备2021005235号-2</span>
      </div>
      <div class="fot_item">
        Copyright © 2021 湖北冰火网络科技有限公司 版权所有
      </div>
      <div class="fot_item">
        <div class="item">
          <img src="@/assets/footer/ico_china2.png" class="icon26" alt="" srcset="">
          <span class="ju" @click="jumpIp('https://www.12377.cn/')"> 中国互联网举报中心 </span>
        </div>
        <div class="item">
          <img src="@/assets/footer/ico_weifa2.png" class="icon26" alt="" srcset="">
          <span class="ju" @click="jumpIp('http://cyberpolice.mps.gov.cn/wfjb/')"> 网络违法举报中心 </span>
        </div>
        <div class="item">
          <img src="@/assets/footer/ico_lese.png" class="icon26" alt="" srcset="">
          <span class="ju" @click="jumpIp('https://www.12321.cn/')"> 垃圾信息举报中心 </span>
        </div>
        <div class="item">
          <img src="@/assets/footer/ico-fchm1.png" class="icon26" alt="" srcset="">
          <span> 已接入中宣部网络游戏防沉迷实名认证系统 </span>
        </div>
        <div class="item">
          <img src="@/assets/footer/ts.png" class="icon20" alt="" srcset="">
          <span class="ju" @click="jumpIp('https://jubao.chinaso.com/')"> 防沉迷举报平台 </span>
        </div>
      </div>
      <div class="fot_item">
        抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      jumpIp(url) {
        window.open(url, '_blank');
      }
    }
  }
</script>

<style lang="less">
  .footer {
    // position: fixed;
    // width: 100vw;
    height: 130px;
    background-color: #112e4e;
    // bottom: 0;
    // padding-top: 10px;
    box-sizing: border-box;
    // z-index: 999;
    overflow: hidden;
    margin-top: 20px;

    .fot_item {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: white;
      margin-top: 8px;

      .item {
        display: flex;
        align-items: center;
        margin-left: 5px;

        .ju:hover {
          color: #29D894;
          cursor: pointer;
        }
      }

      .icon20 {
        width: 20px;
        height: 20px;
        margin-right: 3px;
      }

      .icon26 {
        width: 26px;
        height: 26px;
        margin-right: 3px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/component/foot.vue